import { render } from "./EmergencyModal2.vue?vue&type=template&id=4d44ffeb&scoped=true"
import script from "./EmergencyModal2.vue?vue&type=script&lang=js"
export * from "./EmergencyModal2.vue?vue&type=script&lang=js"

import "./EmergencyModal2.vue?vue&type=style&index=0&id=4d44ffeb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d44ffeb"]])

export default __exports__